/**
 * Feature Flags Configuration
 *
 * Use these flags to enable/disable features without code changes.
 * Can be controlled via environment variables or hardcoded defaults.
 */
export var featureFlags = {
    /**
     * Use the new scrollable date picker for extend booking date selection
     *
     * The new picker provides:
     * - Scrollable list of dates instead of calendar grid
     * - Better mobile UX with collapsible interface
     * - Consistent with the new booking flow date selection
     *
     * Set REACT_APP_USE_SCROLLABLE_DATE_PICKER_FOR_EXTENSION=true to enable
     * Default: false (uses the original react-datepicker inline calendar)
     */
    useScrollableDatePickerForExtension: process.env.REACT_APP_USE_SCROLLABLE_DATE_PICKER_FOR_EXTENSION === 'true',
    /**
     * Use interactive checkout date picker (bidirectional selection)
     *
     * When enabled:
     * - Checkout date picker is interactive (not read-only)
     * - Selecting a checkout date highlights the corresponding nights button
     * - Selecting a nights button updates the checkout date
     * - Both methods stay in sync
     *
     * When disabled:
     * - Checkout date is read-only (calculated from nights selection)
     * - User can only select nights, checkout date updates automatically
     *
     * Set REACT_APP_USE_INTERACTIVE_CHECKOUT_PICKER=true to enable
     * Default: false (checkout date is read-only)
     */
    useInteractiveCheckoutPicker: process.env.REACT_APP_USE_INTERACTIVE_CHECKOUT_PICKER === 'true',
    /**
     * Booking authentication method for the ManageBookingPage
     *
     * Controls which authentication flow is used for truck drivers to access their bookings:
     * - 'otp': Original OTP verification flow (default)
     * - 'magic_link': New Magic Link flow with Full Dashboard
     * - 'both': Show both options, let user choose
     *
     * The Magic Link flow provides:
     * - 72-hour persistent sessions
     * - Full Dashboard with booking history and stats
     * - Single tap authentication from SMS
     *
     * Set REACT_APP_BOOKING_AUTH_METHOD=magic_link to enable
     * Default: 'otp' (original OTP flow)
     */
    bookingAuthMethod: (process.env.REACT_APP_BOOKING_AUTH_METHOD || 'otp'),
    /**
     * Enable customer monthly subscriptions experience in dashboard.
     *
     * Set REACT_APP_ENABLE_MONTHLY_SUBSCRIPTIONS=true to enable.
     * Default: false
     */
    enableMonthlySubscriptions: process.env.REACT_APP_ENABLE_MONTHLY_SUBSCRIPTIONS === 'true',
    /**
     * Controls public hiring visibility.
     *
     * Set REACT_APP_PUBLIC_HIRING_ENABLED=false to hide public hiring routes,
     * homepage/pricing hiring promotions, and public footer/contact hiring links.
     * Customer dashboard/profile hiring entry points remain available.
     * Default: true
     */
    publicHiringEnabled: process.env.REACT_APP_PUBLIC_HIRING_ENABLED !== 'false',
};
/**
 * Helper function to get feature flag value
 * Use this for accessing flags in JS files that can't import TypeScript directly
 */
export var getFeatureFlag = function (flagName) {
    return featureFlags[flagName];
};
